export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=707f99491745403fbc6cee1a5850ef3f2f58eea0ff&name=pushAdClickData!'